<template>
  <div class="relative">
    <button
      v-if="excludedEmails.length"
      class="flex h-7 w-16 cursor-pointer items-center justify-center rounded-full border border-blue-500 pt-1 text-blue-500"
      @click.prevent="toggleEmailDropdown"
    >
      <icon-base :icon="IconAddSmall" />

      <span class="text-xs font-normal">{{ $t("COMMON.ADD") }}</span>
    </button>
    <div
      v-if="showEmailMenu"
      class="absolute top-8 left-0 z-10 min-w-max rounded-md bg-white py-2-5 text-sm text-gray-500 shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm"
    >
      <ul
        class="max-h-50 overflow-y-auto"
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-item-3"
      >
        <li
          class="flex cursor-pointer justify-start overflow-auto py-2 hover:bg-gray-200"
        >
          <span class="ml-2 w-full font-normal">
            <lf-checkbox
              v-if="availableEmails.length > 1"
              v-model="allSelected"
              :value="true"
              name="selected_all"
              @click="toggleSelectAll"
            >
              {{ $t("SIDEBAR.BUSINESS_CREDIT_DEALS.ALL") }}
            </lf-checkbox>
          </span>
        </li>
        <li
          v-for="(email, idx) in availableEmails"
          :key="email"
          class="flex cursor-pointer justify-start overflow-auto py-2 hover:bg-gray-200"
          role="option"
        >
          <div class="ml-2 w-full space-x-2 font-normal">
            <input
              :id="`${email}-${idx}`"
              v-model="selectedEmails"
              type="checkbox"
              :value="email"
              class="h-4 w-4 rounded-xs border-gray-300"
              @change="emailToggled(email)"
            />
            <label class="font-medium text-gray-500" :for="`${email}-${idx}`">
              {{ email }}
            </label>
          </div>
        </li>
      </ul>
      <hr class="my-1 h-2" />
      <div class="flex px-6">
        <button
          class="mt-2 rounded-sm border border-gray-100 px-6 text-center font-semibold text-gray-400 sm:text-base"
          @click.stop="toggleEmailDropdown"
        >
          {{ $t("COMMON.CANCEL") }}
        </button>
        <primary-button class="mt-2 ml-2 px-10" @click.stop="save">
          {{ $t("COMMON.SAVE") }}
        </primary-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import IconAddSmall from "@/components/icons/deals/IconAddSmall.vue";
import LfCheckbox from "@/components/ui/inputs/LfCheckbox.vue";

const props = defineProps<{
  availableEmails: string[];
  excludedEmails: string[];
}>();

const emit = defineEmits<{
  save: [string[]];
}>();

const showEmailMenu = ref(false);

const selectedEmails = computed(() =>
  props.availableEmails.filter(
    (email) => !excludedEmailsLocal.value.includes(email)
  )
);

const allSelected = computed(
  () => selectedEmails.value.length === props.availableEmails.length
);

const excludedEmailsLocal = ref([...props.excludedEmails]);

const toggleEmailDropdown = () => {
  showEmailMenu.value = !showEmailMenu.value;
};

const save = () => {
  emit("save", excludedEmailsLocal.value);
  showEmailMenu.value = false;
};

const toggleSelectAll = () => {
  excludedEmailsLocal.value = allSelected.value
    ? [...props.availableEmails]
    : [];
};

const emailToggled = (email: string) => {
  if (excludedEmailsLocal.value.includes(email)) {
    excludedEmailsLocal.value = excludedEmailsLocal.value.filter(
      (e) => e !== email
    );
  } else {
    excludedEmailsLocal.value.push(email);
  }
};

watch(
  () => props.excludedEmails,
  () => {
    excludedEmailsLocal.value = [...props.excludedEmails];
  }
);
</script>
